import root from 'window-or-global';
import React from 'react';
import {Helmet} from 'react-helmet';
import getTagsFromModel from 'epic-node-cms/src/cmsUtils/metaUtils';

export default function getAssetPath(asset) {
    return `${root.__webpack_asset_path || ''}${asset}`;
}

export function getHelmetForMetaTags(pageModel) {
    if (!pageModel) return null;

    const {tags, title} = getTagsFromModel(pageModel);

    return <Helmet meta={tags} title={title} />;
}
